<template>
  <div class="candidate-expired-recruitment" :style="backgroundImg">
    <h3>
      {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.CANDIDATE.@RECRUITMENT_EXPIRED_TITLE")) }}
    </h3>
    <h3>
      {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.CANDIDATE.@RECRUITMENT_EXPIRED_SUBTITLE")) }}
    </h3>
    <h3>
      {{ $filters.whitespacedPunctuation($t("ETAB.PAGES.CANDIDATE.@RECRUITMENT_EXPIRED_CALL_TO_ACTION")) }}
    </h3>

    <QBtn
      class="full-width btn-navigation"
      no-caps
      color="secondary"
      :label="$t('ETAB.PAGES.CANDIDATE.@RECRUITMENT_EXPIRED_ACTION')"
      @click="goToCreateDemand()"
    />
  </div>
</template>

<script setup>
  import { ETAB_ROUTES } from "@etab/config";
  import placeholderImg from "@etab/assets/img/placeholders/candidate_current_placeholder_transparent.png";
  import { computed } from "vue";
  import { useRouter } from "vue-router";

  const router = useRouter();

  // Computed
  const backgroundImg = computed(() => {
    return { background: `url(${placeholderImg}) no-repeat center center` };
  });

  // Methods
  const goToCreateDemand = function () {
    router.push({ name: ETAB_ROUTES.creation.root.name }).catch((suppressedError) => {});
  };
</script>

<style lang="scss">
  .candidate-expired-recruitment {
    text-align: center;
    padding: 30px 15px;

    h3 {
      line-height: 1;
      margin: 50px 0;
      font-weight: bold;

      &:first-of-type {
        margin: 0 0 125px;
      }
    }
  }
</style>
